import React from "react"
import MaterialIcon from "../../../../../components-shared/material-icon/material-icon-view"
import styles from "./selectable-value.module.scss"

export interface SelectableValueProps {
  isExpanded: boolean
  onSetExpanded: (isExpanded: boolean) => void
}

export const SelectableValue: React.FC<SelectableValueProps> = ({ isExpanded, onSetExpanded, children }) => {
  return <span className={styles.SelectableValue} onClick={() => onSetExpanded(!isExpanded)}>
    {children}
    <MaterialIcon name={isExpanded ? "expand_less" : "expand_more"}/>
  </span>
}